module.exports = __webpack_public_path__ + "img/pe.8f3c0bbb.svg";